// Screen `component builder` (owner: custom-components, F20): the visual builder of a custom component.
import { Suspense, lazy } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@dataroom/ui';

const ComponentBuilder = lazy(() => import('../../../features/custom-components/builder/ComponentBuilder').then((m) => ({ default: m.ComponentBuilder })));

export const Route = createFileRoute('/_focus/components/$id')({
  component: function ComponentBuilderRoute() {
    const { id } = Route.useParams();
    return (
      <Suspense fallback={<Spinner />}>
        <ComponentBuilder key={id} id={id} />
      </Suspense>
    );
  },
});
